import { render, staticRenderFns } from "./tsItem.vue?vue&type=template&id=7f411d44&scoped=true"
import script from "./tsItem.vue?vue&type=script&lang=js"
export * from "./tsItem.vue?vue&type=script&lang=js"
import style0 from "./tsItem.vue?vue&type=style&index=0&id=7f411d44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f411d44",
  null
  
)

export default component.exports